import styled from "styled-components";

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
`;

const Placeholder = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    background-color: #fafafa;
    color: #666;
    font-size: 14px;
    text-align: center;
    padding: 24px;
`;

const Content = () => {
    return (
        <PageContent>
            <Placeholder>
                Listagem e preenchimento das inspeções ambientais em construção.
            </Placeholder>
        </PageContent>
    );
};

export default Content;
